import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PartnerActivityService } from 'app/shared/services/partner-activity/partner-activity.service';
import { AuthenticationService } from 'app/core/authentication';
import { PartnerActivityApiService } from 'app/shared/services/partner-activity/partner-activity-api.service';
import { IClass, IClassResponse, IPartner, IPartnerParams } from 'app/shared/models/partner-activity.model';

@Component({
    selector: 'kh-partner-activity',
    imports: [RouterModule],
    templateUrl: './partner-activity.component.html',
    styleUrl: './partner-activity.component.less'
})
export class PartnerActivityComponent implements OnInit {
  constructor(
    private partnerActivityService: PartnerActivityService,
    private authService: AuthenticationService,
    private apiService: PartnerActivityApiService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(
      map(params => this.partnerActivityService.getPartner(params.Partner)),
      switchMap(partner => this.handlePartner(partner))
    ).subscribe();
  }

  private handlePartner(partner: IPartner): Observable<void> {
    const queryParams = this.route.snapshot.queryParams;

    const partnerParams: IPartnerParams = {
      PublicUnitId: queryParams.PublicUnitId || '', // Default to empty string if undefined
      CourseId: queryParams.CourseId || '',
      CountryCode: queryParams.CountryCode || '',
      RegionCode: queryParams.RegionCode || '',
      ClassId: queryParams.ClassId || '',
      PartnerId: queryParams.Partner
  };
    
    if (partner && partner.initializePartner(partnerParams, partner.Params.PartnerId)) {
      if (!this.authService.isTransient()) {
        if (this.authService.isInRole('Teacher')) {
          return this.handleTeacherPartner(partner);
        }
        if (this.authService.isAuthorized()) {
          return partner.signInAsGuest().pipe(
            map(() => partner.redirectToStartPage())
          );
        }
      }
      return partner.signInAsGuest().pipe(
        map(() => partner.redirectToStartPage())
      );
    } else {
      this.router.navigate(['PageNotFound']);
      return of();
    }
  }

  private handleTeacherPartner(partner: IPartner): Observable<void> {
      
      return this.apiService.getClasses().pipe(
        map((response: IClassResponse) => {
          if (response.Classes && response.Classes.length > 0) {
            partner.redirectToStartPage(response.Classes[0].ClassId);
          } else {
            this.createNewClass(partner);
          }
        })
      );
    }

  private createNewClass(partner: IPartner): void {
    const params = this.route.snapshot.queryParams;
    
    this.apiService.createClass(params).subscribe((newClass: IClass) => {
      partner.redirectToStartPage(newClass.ClassId);
    });
  }
}
